import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=501ecf4a&"
import script from "./UserDropdown.vue?vue&type=script&lang=js&"
export * from "./UserDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501ecf4a')) {
      api.createRecord('501ecf4a', component.options)
    } else {
      api.reload('501ecf4a', component.options)
    }
    module.hot.accept("./UserDropdown.vue?vue&type=template&id=501ecf4a&", function () {
      api.rerender('501ecf4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/components/UserDropdown.vue"
export default component.exports